import React from "react";

export default function PrivacyPolicy({}) {
	return (
		<React.Fragment>
			<div>
				<p><b>Introduction</b></p>
				<p>
					Karls Technology is committed to protecting the privacy of our customers. This Privacy Policy outlines how we receive and use the contact information you provide to us in connection with our computer repair services. By using our services, you agree to the terms of this Privacy Policy.
				</p>

				<p><b>Types of Information</b></p>
				<p>We receive the following types of personal information from our customers:</p>

				<ul>
					<li>Name</li>
					<li>Email address</li>
					<li>Phone number</li>
				</ul>

				<p><b>Method of Receiving Customer Information</b></p>
				<p>We only receive customer information when you book an appointment with us, either through our website or over the phone.</p>

				<p><b>Purpose of Data Collection</b></p>
				<p>The information you provide is not collected and is used solely for the following purposes:</p>

				<ul>
					<li>To contact you regarding your appointment.</li>
					<li>To provide updates or changes related to your appointment</li>
					<li>To confirm and remind you of your scheduled appointment.</li>
				</ul>

				<p><b>Data Security Measures</b></p>
				<p>We take the security of your personal information seriously. For this reason, we do not collect any information about you and only use the provided information for the purposes listed above pertaining to your appointment.</p>

				<p><b>Data Sharing</b></p>
				<p>We do not share your personal information with any third parties, except as necessary to provide our services or as required by law. SMS opt-in or phone numbers for the purpose of SMS are not being shared.</p>

				<p><b>User Rights</b></p>
				<p>You have the right to access, update, or delete the personal information we have received from you. If you wish to exercise these rights, please contact us using the details provided below.</p>

				<p><b>Contact Information</b></p>
				<p>If you have any questions or concerns about this Privacy Policy or your personal information, please contact us at:</p>

				<p>Karls Technology</p>
				<p>1-800-620-5285</p>
				<p>dispatch@karlstechnology.com</p>
			</div>
		</React.Fragment>
	)
}